module.exports = __webpack_public_path__ + "static/media/download-icon.aa0c9d6b.svg";